<template>
	<div class="message-bubble">
		<span>Para continuar, nos indicas tu email</span>
	</div>
</template>

<script>
export default {
	data: () => ({
		messages: [],
	}),
	created() {},
	methods: {},
};
</script>